import { Component, effect, inject } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../menu/menu.component';
import { UserRole, UserRoleIds } from 'src/app/models/security/user-role-enum';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  standalone: true,
  selector: 'app-layout-admin',
  imports: [CommonModule, RouterOutlet, RouterModule, FooterComponent, HeaderComponent, MenuComponent],
  templateUrl: './layout-admin.component.html',
  styles: ``
})
export class LayoutAdminComponent {

  authService = inject(AuthService);

  currentRole: string | null = '';
  isLoggedIn: boolean = false;

  roles = UserRole;

  constructor() {
    effect(() => {
      this.isLoggedIn = this.authService.isLoggedIn()
    });
  }

  ngOnInit(): void {
    this.currentRole = this.authService.getUserRoleId();
  }
  toggleMenu(): void {
    let appMain: HTMLElement | null = document.getElementById('app-main');
    if (appMain != null) {
      appMain.classList.toggle('open-menu');
    }
  }
}
